import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-944ab670"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["aria-label"]
const _hoisted_2 = { class: "status-tooltip__title" }
const _hoisted_3 = { class: "status-tooltip__body" }

import { computed, ref, type CSSProperties } from 'vue'
import { getStatusMetadata } from '@/utils/statusUtils'


export default /*#__PURE__*/_defineComponent({
  __name: 'StatusBadgeComponent',
  props: {
    lastOnline: {}
  },
  emits: ["click"],
  setup(__props: any) {

const props = __props;





const showTooltip = ref(false)
const badgeRef = ref<HTMLElement | null>(null)
const tooltipPos = ref({ top: 0, left: 0 })

const status = computed(() => getStatusMetadata(props.lastOnline))

const tooltipStyle = computed<CSSProperties>(() => ({
  position: 'fixed',
  bottom: `${tooltipPos.value.bottom}px`,
  left: `${tooltipPos.value.left}px`,
  zIndex: 9999,
}))

function onMouseEnter() {
  if (badgeRef.value) {
    const rect = badgeRef.value.getBoundingClientRect()
    tooltipPos.value = {
      // position above the badge with 8px gap
      bottom: window.innerHeight - rect.top + 8,
      // left-align: arrow sits at badge center, offset tooltip so arrow is ~14px from left
      left: rect.left + rect.width / 2 - 14,
    }
  }
  showTooltip.value = true
}

function onMouseLeave() {
  showTooltip.value = false
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "status-badge-wrapper",
    ref_key: "badgeRef",
    ref: badgeRef,
    onMouseenter: onMouseEnter,
    onMouseleave: onMouseLeave
  }, [
    _createElementVNode("button", {
      type: "button",
      class: "status-circle",
      style: _normalizeStyle({ backgroundColor: status.value.color }),
      "aria-label": `${status.value.label}. Last online: ${status.value.timeAgo}`,
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('click')))
    }, null, 12, _hoisted_1),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createVNode(_Transition, { name: "status-tooltip-fade" }, {
        default: _withCtx(() => [
          (showTooltip.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "status-tooltip",
                style: _normalizeStyle(tooltipStyle.value)
              }, [
                _createElementVNode("div", _hoisted_2, _toDisplayString(status.value.label) + ".", 1),
                _createElementVNode("div", _hoisted_3, "Last online: " + _toDisplayString(status.value.timeAgo) + ".", 1)
              ], 4))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]))
  ], 544))
}
}

})